export const paymentMethodNames = new Map([
    ["cash", "Gotówka"],
    ["electronic", "Elektronicznie"],
]);
export const stateNames = new Map();
stateNames.set("while_ordering", "W trakcie zamawiania");
stateNames.set("waiting_for_payment", "Oczekuje na płatność");
stateNames.set("payed", "Opłacone");
stateNames.set("complete", "Wykonane");
export const merchantStates = new Map();
merchantStates.set("unspecified", "Zarejestrowane");
merchantStates.set("working", "Przyjęte");
merchantStates.set("exported", "Wyeksportowane");
merchantStates.set("completed", "Wykonane");
merchantStates.set("delivered", "Dostarczone");
